<template>
  <div>
    <div>
      <span class="font-weight-bold"
        >{{ $t("feedback.link_mission.title") }}:</span
      >
      <p class="pre-formatted">{{ feedback.link_mission | capitalize }}</p>
    </div>
    <div>
      <span class="font-weight-bold"
        >{{ $t("feedback.overall_impression.title") }}:</span
      >
      <p class="pre-formatted">
        {{ feedback.overall_impression | capitalize }}
      </p>
    </div>
    <div>
      <span class="font-weight-bold"
        >{{ $t("feedback.detailed_assessment.title") }}:</span
      >
      <p class="pre-formatted">
        {{ feedback.detailed_assessment | capitalize }}
      </p>
    </div>
    <div>
      <span class="font-weight-bold"
        >{{ $t("feedback.recommendation.title") }}:</span
      >
      <p class="pre-formatted">{{ feedback.recommendation | capitalize }}</p>
    </div>
    <div>
      <span class="font-weight-bold"
        >{{ $t("feedback.follow_instruction.title") }}:</span
      >
      <p class="pre-formatted">
        {{ feedback.follow_instruction | capitalize }}
      </p>
    </div>
    <div>
      <span class="font-weight-bold">{{ $t("feedback.visible_by") }}:</span>
      {{
        feedback.visible_by
          .map((e) => $t("common.role." + e.toLowerCase()))
          .join(", ")
      }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Feedback",
  props: {
    feedback: {
      type: Object,
    },
  },
}
</script>
